import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import CAxios from "../utils/CAxios";
import { hyperPayApiBase } from "../../utils/hyperPay";

/**
 *
 * save payment
 */

export const toSavePayment = createAsyncThunk(
  "payment/save",
  async ({ data, lang }: { data: any; lang: string }) => {
    try {
      const response = await CAxios.post(
        `payment?lang=${lang}`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

/***
 *
 * HYPER PAY
 */

export const toPrepareCheckout = createAsyncThunk(
  "hyperpay/toPrepareCheckout",
  async ({
    data,
    token,
    hyperPayUrl,
  }: {
    data: any;
    token: string;
    hyperPayUrl: string;
  }) => {
    try {
      const response = await axios.post(`${hyperPayApiBase(hyperPayUrl)}/checkouts`, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`, // Dynamic token
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
);

/// check hyper pay status
/**
 * HYPER PAY STATUS CHECK
 */

export const toCheckHyperPayStatus = createAsyncThunk(
  "hyperpay/checkStatus",
  async (
    {
      checkoutId,
      entityId,
      token,
      base_url,
    }: {
      checkoutId: string;
      entityId: string;
      token: string;
      base_url: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(
        `${hyperPayApiBase(base_url)}/checkouts/${checkoutId}/payment`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            entityId,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "HyperPay status check failed"
      );
    }
  }
);

/**
 *
 * TABBY
 */
const tabbyUrl = "https://api.tabby.ai/api/v2/checkout";
const key = "sk_test_bc7d2590-c96a-4659-965e-c60ee95b400c";

export const toGetTabbyUrl = createAsyncThunk(
  "tabby/toGetTabbyUrl",
  async (data: any) => {
    try {
      const response = await axios.post(tabbyUrl, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
);

/**
 *
 * MY LIST
 */

export const toCheckMyListBalance = createAsyncThunk(
  "mylist/checkBalance",
  async (
    {
      cardNumber,
      baseURL,
      Token,
      AutoChapeauIp,
    }: {
      cardNumber: string;
      baseURL: string;
      Token: string;
      AutoChapeauIp?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      // Form data format for GET
      const params = new URLSearchParams();
      params.append("card_number", cardNumber);

      const response = await axios.get(
        `${baseURL}/api/v1/currency/giftcards/balance_check`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            ...(AutoChapeauIp && { "x-forwarded-for": AutoChapeauIp }),
          },
          params,
        }
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Balance check failed");
    }
  }
);
const myListAPI =
  "https://testapi.meritincentives.com/api/v1/currency/giftcards/spend";
const myListKey = "secret_test_VGyauOyZzvgb5GV3d_REgDmVQELUOiij8J27Kitdixc";
export const toSendMyList = createAsyncThunk(
  "mylist/send",
  async ({
    data,
    baseURL,
    Token,
    AutoChapeauIp,
  }: {
    data: any;
    baseURL: string;
    Token: string;
    AutoChapeauIp?: string;
  }) => {
    try {
      const response = await axios.post(
        `${baseURL}/api/v1/currency/giftcards/spend`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            ...(AutoChapeauIp && { "x-forwarded-for": AutoChapeauIp }),
          },
        }
      );

      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface YouGotaGiftConfig {
  username: string;
  password: string;
  baseUrl: string;
}

interface RedeemGiftCardData {
  store_staff_position: string;
  store_staff_name: string;
  store_location: string;
  code: string;
  reference_id: string;
  config: YouGotaGiftConfig;
}

export const toSendYouGotaGift = createAsyncThunk(
  "youGotaGift/send",
  async (data: RedeemGiftCardData, { rejectWithValue }) => {
    const { config, ...payload } = data;

    try {
      const basicAuth = btoa(`${config.username}:${config.password}`);
      const formData = new FormData();
      formData.append("store_staff_position", payload.store_staff_position);
      formData.append("store_staff_name", payload.store_staff_name);
      formData.append("store_location", payload.store_location);
      formData.append("code", payload.code);
      formData.append("reference_id", payload.reference_id);

      const apiEndpoint = `${config.baseUrl}/api/v1-1/redeem/`;

      const response = await axios.post(apiEndpoint, formData, {
        headers: {
          Authorization: `Basic ${basicAuth}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Redemption failed");
    }
  }
);

// to post you gift data

export const toSendYouGotaGiftData = createAsyncThunk(
  "gotagift/history",
  async (data: any) => {
    try {
      const response = await CAxios.post(
        `yougotagift/loyalty/history`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

// to get tabby keys
export const toGetTabbyKeys = createAsyncThunk("keys/Tabby", async () => {
  try {
    const response = await CAxios.get(`keys/tabby`);
    return response;
  } catch (error) {
    throw error;
  }
});
// to send mylist data
export const toSendMylistData = createAsyncThunk(
  "mylist/history",
  async (data: any) => {
    try {
      const response = await CAxios.post(
        `mylist/loyalty/history`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);

// to send tabby to backend
export const toSendTabbyApi = createAsyncThunk(
  "Tabby/Api",
  async (data: any) => {
    try {
      const response = await CAxios.post(`tabby`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to Capture Payment for
export const toCapturePayment = createAsyncThunk(
  "Tabby/CapturePayment",
  async (data: any) => {
    try {
      const response = await CAxios.post(`tabby/capture`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
// to get Mylist keys
export const toGetMylistKeys = createAsyncThunk("keyss/mylist", async () => {
  try {
    const response = await CAxios.get(`keys/mylist`);
    return response;
  } catch (error) {
    throw error;
  }
});
// to get hyperpay keys
export const toGetHyperPayKeys = createAsyncThunk(
  "keys/hyperpay",
  async () => {
    try {
      const response = await CAxios.get(`keys/hyperpay`);
      return response;
    } catch (error) {
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const status = (
        getState() as { tabby: { HyperPayKeys: { status: string } } }
      ).tabby.HyperPayKeys.status;
      return status !== "loading" && status !== "succedded";
    },
  }
);

// to get Yougotagift Keys
export const toGetYougotaGiftKeys = createAsyncThunk(
  "keys/yougotagift",
  async () => {
    try {
      const response = await CAxios.get(`keys/yougotagift`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

/** Wallet top-up step 1: reserve a top-up (balance unchanged), returns `topup_id`. */
export const toPrepareWalletTopUp = createAsyncThunk(
  "wallet/topupPrepare",
  async (data: { amount: number; payment_brand: string }) =>
    CAxios.post(`wallet/topup/prepare`, data)
);

/** Wallet top-up step 2: credit the wallet after HyperPay succeeded. Idempotent per `topup_id`. */
export const toConfirmWalletTopUp = createAsyncThunk(
  "wallet/topupConfirm",
  async (data: { topup_id: number; transaction_id: string }) =>
    CAxios.post(`wallet/topup/confirm`, data)
);
